import { twMerge } from 'tailwind-merge';

/** shadcn-style loading placeholder. Size it with Tailwind (`h-4 w-32`), not MUI `width`/`height`. */
export default function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={twMerge('animate-pulse rounded-md bg-bluegray-200', className)} {...props} />;
}
